import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initAnalytics } from './lib/analytics';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root is missing from index.html');
}

// Fire-and-forget init: lazy-imports posthog-js, registers global
// properties, and respects the opt-out flag. Capturing events before
// this resolves is safe — the wrapper queues them on the init promise.
void initAnalytics();

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
